package fr.arcplex.sooner

actual fun getPlatformUtils(): PlatformUtils = DefaultPlatformUtils
